import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslations } from "next-intl";
import { Ui } from "@silvertours/front-shared";
import { FeedbackSummary } from "./FeedbackSummary";
import { ReviewList } from "./ReviewList";
import { FeedbackContainer } from "./Reviews.styles";
var Feedback = function(props) {
    var t = useTranslations("features.trustLegacy.feedback.feedbackGroup.groupLink");
    var hideSummaryDescription = props.hideSummaryDescription, groupLink = props.groupLink;
    var name = t("name");
    var path = t("path");
    return /*#__PURE__*/ _jsxs(FeedbackContainer, {
        hasSummary: !hideSummaryDescription,
        children: [
            /*#__PURE__*/ _jsx(FeedbackSummary, _object_spread({}, props)),
            /*#__PURE__*/ _jsx(ReviewList, _object_spread({}, props)),
            !!groupLink && /*#__PURE__*/ _jsxs("span", {
                children: [
                    /*#__PURE__*/ _jsx(Ui.TextLink, {
                        text: name,
                        href: path
                    }),
                    " \xa0>"
                ]
            })
        ]
    });
};
export { Feedback };
